import { render, staticRenderFns } from "./PdfPage.vue?vue&type=template&id=61153db9&scoped=true"
import script from "./PdfPage.vue?vue&type=script&lang=js"
export * from "./PdfPage.vue?vue&type=script&lang=js"
import style0 from "./PdfPage.vue?vue&type=style&index=0&id=61153db9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61153db9",
  null
  
)

export default component.exports